export default __webpack_public_path__ + "static/What-1000-a-Month-Accommodation-Gets-You-Around-the-World-fe8e5678e002e3cb437942670b02963a.jpg";